import { getAlertMessage } from 'Alerts/AlertMessages'
import Cleave from "cleave.js/react";
import ErrorTooltip from 'Components/ErrorTooltip'
import PopUp from 'Components/PopUp';
import ThreeStateSwitch from 'Components/ThreeStateSwitch'
import ToolTip from 'Components/ToolTip'
import { TooltipMsg } from 'Components/ToolTipMessage'
import env from 'environment_system/env_system'
import { calculateUTCTime, filterUniqueByFields, calculateTimeDurationBetwnReports, disableEditFields, saveEditForm, checkValidObject, dateTimeFormat } from 'GenericForms/Helper'
import { RootState } from 'index';
import React, { useEffect, useState } from 'react'
import { useSelector } from 'react-redux';
import Select from 'react-select'
import { CardBody, Row, Col, Label, Input, Button, CardFooter } from 'reactstrap'
import { customStyle } from 'shared/CommonCSS'
import {
    EventPrecedence,
    OperationPrecedence,
    ReportingEvents,
    ReportingTypeConstant,
    AlertColourTypeConstant,
    AlertTypeConstant,
    VesselTypeConstant,
    ManeouveringTimeLimit
} from 'shared/constants'
import FormValuesDebug from 'utils/debugTools/FormValuesDebug'
import { useEditReport } from './EditReportProvider';
const CleaveInput: any = Cleave as any;
const CreateVesselReportStructure = ({
    CreateVesselReportFormik,
    refreshKey,
    voyage,
    alertBool,
    setAlertBool,
    handleReportingDateTimeChanges,
    handleTimePrefixSwitchChanges,
    handleTimeDifferenceTextboxChanges,
    verifyAdvancedRetarded,
    handleIsCIIReportSwitchChanges,
    refreshCheckboxes,
    handleIsNoonReportSwitchChanges,
    setCount,
    reportingEvent,
    reportingType,
    additionalEvents,
    handleReportingEventDropdownChanges,
    generateDistanceAlert,
    setAlertMessage,
    setAlertColourType,
    setAlertType,
    setFieldId,
    LoadConditionOptions,
    StraitCanals,
    setRefreshKey,
    count,
    submitBool,
    setSubmitBool,
    OtherSettings,
    editSubmit,
    editIsSubmitting,
    setAlertFieldLabel,
    setAlertFieldValue,
    refreshDistance,
    refreshFields,
    setRefreshFieldApplicable,
}: any) => {
    const { editReportBool, activeEditTab, toggle, discardwarning } = useEditReport();
    const { VesselState, CurrentVessel, CurrentReport, PreviousReport } = useSelector((state: RootState) => state.Reporting);
    const currentVesselReport = CurrentReport?.data?.vessel_reporting_information ?? null;
    const previousVesselReport = PreviousReport?.data?.vessel_reporting_information ?? null;
    const [previousLoadCondition, setPreviousLoadCondition] = useState(null);
    const [showTooltipBool, setShowTooltipBool] = useState(true);
    /** Clear remaining distance to next port if it's set to 0 
     * when reporting type is INPORT. This is to avoid
     * the error "Please enter a valid number" when
     * the user tries to save the form if this field is disabled.
    */
    useEffect(() => {
        if (reportingType === ReportingTypeConstant.INPORT) {
            // Avoid setting if already 0
            const currentValue = CreateVesselReportFormik?.values?.remaining_distance_to_the_next_port;
            if (currentValue !== 0) {
                CreateVesselReportFormik.setFieldValue("remaining_distance_to_the_next_port", 0);
            }
        }
        // eslint-disable-next-line react-hooks/exhaustive-deps
    }, [reportingType]);
    /** Filter the event options based on the additional events switch */
    const eventOptions = CreateVesselReportFormik?.values?.additional_events === false
        ? reportingEvent?.[0]?.next_possible_events?.next_possible_events
            ?.filter((item: any) => item.event_precedence_id !== EventPrecedence.CII_ADJUSTMENT_EVENT &&
                item.event_precedence_id !== EventPrecedence.NOON)
        : filterUniqueByFields(
            additionalEvents?.[0]?.next_possible_events?.next_possible_events,
            ['id']
        );
    /** Get the selected event */
    const selectedEvent = eventOptions?.find(
        (opt: any) => opt.id === CreateVesselReportFormik.values.reporting_event
    );

    return (
        <CardBody>
            <form noValidate autoComplete='off' onSubmit={CreateVesselReportFormik?.handleSubmit} key={refreshKey}>
                <Row >
                    <div className="card w-100" style={{ background: "#fff9e6" }}>
                        <div className="card-body p-1">
                            <h5 className="card-title p-0 text-dark">Previous report summary</h5>
                            <div className='d-flex gap-3'>
                                <div>
                                    <Label className="mb-0 font-size-12" >
                                        Previous reporting event name : <span className="fw-bold ms-1">{checkValidObject(previousVesselReport) ? previousVesselReport?.reporting_event_name : "-"}</span>
                                    </Label>
                                </div>
                                <div>
                                    <Label className="mb-0 font-size-12" >
                                        Previous reporting date & time : <span className="fw-bold ms-1">{previousVesselReport?.local_time
                                            ? dateTimeFormat(
                                                previousVesselReport?.local_time,
                                                false,
                                                false,
                                                true
                                            )
                                            : dateTimeFormat(
                                                previousVesselReport?.reporting_time_utc || "-",
                                                false,
                                                false,
                                                true
                                            )}</span>
                                    </Label>
                                </div>
                            </div>
                        </div>
                    </div>
                </Row>
                <Row>
                    <Col lg={4} className="mb-2">
                        <h4 >Vessel Reporting</h4>
                        <strong>Voyage number:  {voyage && voyage.voyage_number}</strong>
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col lg={4}>
                        <React.Fragment>
                            <Label className='mb-0'>UTC time: </Label><br />
                            <h5
                                className={`mb-0 mt-1 ${calculateUTCTime(
                                    CreateVesselReportFormik?.values?.local_time,
                                    CreateVesselReportFormik?.values?.reporting_time_difference,
                                    CreateVesselReportFormik?.values?.id
                                )
                                    ? ""
                                    : "text-muted"
                                    }`}
                            >
                                {dateTimeFormat(calculateUTCTime(
                                    CreateVesselReportFormik?.values?.local_time,
                                    CreateVesselReportFormik?.values?.reporting_time_difference,
                                    CreateVesselReportFormik?.values?.id
                                ), false, false, true) || "DD-MM-YYYY HH:MM"}
                            </h5>
                        </React.Fragment>
                    </Col>
                    <Col>
                        <Label className="mb-0 asteric" for="position_lat_deg">
                            Vessel position (Latitude)<i className="bx bx-info-circle ml-2p" id="position_lat_deg_lbl" />
                        </Label>
                        <ToolTip
                            target="position_lat_deg_lbl"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "position_lat_deg_lbl")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <div className="d-flex gap-1">
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control text-right max-width-4"
                                id="position_lat_deg"
                                name="position_lat_deg"
                                placeholder="deg"
                                onBlur={CreateVesselReportFormik?.handleBlur}
                                onChange={(e: any) => CreateVesselReportFormik?.handleChange(e)}
                                defaultValue={CreateVesselReportFormik?.values?.position_lat_deg}
                            />
                            {CreateVesselReportFormik?.errors.position_lat_deg && CreateVesselReportFormik?.touched.position_lat_deg &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={`position_lat_deg`}
                                        message={CreateVesselReportFormik?.errors?.position_lat_deg}
                                        open={CreateVesselReportFormik?.errors?.position_lat_deg ? true : false}
                                    />
                                )}
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control text-right max-width-4"
                                id="position_lat_min"
                                name="position_lat_min"
                                placeholder="min"
                                onBlur={CreateVesselReportFormik?.handleBlur}
                                onChange={(e: any) => CreateVesselReportFormik?.handleChange(e)}
                                defaultValue={CreateVesselReportFormik?.values?.position_lat_min}
                            />
                            {CreateVesselReportFormik?.errors.position_lat_min && CreateVesselReportFormik?.touched.position_lat_min &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"position_lat_min"}
                                        message={CreateVesselReportFormik?.errors.position_lat_min}
                                        open={CreateVesselReportFormik?.errors.position_lat_min ? true : false}
                                    />
                                )}
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control text-right max-width-4"
                                id="position_lat_sec"
                                name="position_lat_sec"
                                placeholder="sec"
                                onBlur={CreateVesselReportFormik?.handleBlur}
                                onChange={(e: any) => CreateVesselReportFormik?.handleChange(e)}
                                defaultValue={CreateVesselReportFormik?.values?.position_lat_sec}
                            />
                            {CreateVesselReportFormik?.errors.position_lat_sec && CreateVesselReportFormik?.touched.position_lat_sec &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"position_lat_sec"}
                                        message={CreateVesselReportFormik?.errors.position_lat_sec}
                                        open={CreateVesselReportFormik?.errors.position_lat_sec ? true : false}
                                    />
                                )}
                            <div id='north_south' className='d-flex align-items-center'>
                                <ThreeStateSwitch
                                    formik={CreateVesselReportFormik}
                                    error={CreateVesselReportFormik?.errors.lat_direction}
                                    touched={CreateVesselReportFormik?.touched.lat_direction}
                                    errorMessage={CreateVesselReportFormik?.errors?.lat_direction}
                                    switchLabel={``}
                                    switchLabelId='north_south'
                                    switchFieldName='lat_direction'
                                    state1Label='N'
                                    state1Id='north'
                                    state1Value={'north'}
                                    state1DefaultValue={CreateVesselReportFormik?.values?.lat_direction === 'north' ? true : false}
                                    state2Label=''
                                    state2Id='lat_direction_na'
                                    state2Value={null}
                                    state2DefaultValue={CreateVesselReportFormik?.values?.lat_direction === null ? true : false}
                                    state3Label='S'
                                    state3Id='south'
                                    state3Value={'south'}
                                    state3DefaultValue={CreateVesselReportFormik?.values?.lat_direction === 'south' ? true : false}
                                    showErrorTooltip={!submitBool}
                                    alertBool={alertBool}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col>
                        <Label className="mb-0 asteric" for="position_long_deg">
                            Vessel position (Longitude)<i className="bx bx-info-circle ml-2p" id="position_long_deg_lbl" />
                        </Label>
                        <ToolTip
                            target="position_long_deg_lbl"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "position_long_deg_lbl")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <div className="d-flex gap-1">
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control text-right max-width-4"
                                id="position_long_deg"
                                name="position_long_deg"
                                placeholder="deg"
                                onBlur={CreateVesselReportFormik?.handleBlur}
                                onChange={(e: any) => CreateVesselReportFormik?.handleChange(e)}
                                defaultValue={CreateVesselReportFormik?.values?.position_long_deg}
                            />
                            {CreateVesselReportFormik?.errors?.position_long_deg && CreateVesselReportFormik?.touched?.position_long_deg &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"position_long_deg"}
                                        message={CreateVesselReportFormik?.errors.position_long_deg}
                                        open={CreateVesselReportFormik?.errors.position_long_deg ? true : false}
                                    />
                                )}
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control text-right max-width-4"
                                id="position_long_min"
                                name="position_long_min"
                                placeholder="min"
                                onBlur={CreateVesselReportFormik?.handleBlur}
                                onChange={(e: any) => CreateVesselReportFormik?.handleChange(e)}
                                defaultValue={CreateVesselReportFormik?.values?.position_long_min}
                            />
                            {CreateVesselReportFormik?.errors.position_long_min && CreateVesselReportFormik?.touched.position_long_min &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"position_long_min"}
                                        message={CreateVesselReportFormik?.errors.position_long_min}
                                        open={CreateVesselReportFormik?.errors.position_long_min ? true : false}
                                    />
                                )}
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control text-right max-width-4"
                                id="position_long_sec"
                                name="position_long_sec"
                                placeholder="sec"
                                onBlur={CreateVesselReportFormik?.handleBlur}
                                onChange={(e: any) => CreateVesselReportFormik?.handleChange(e)}
                                defaultValue={CreateVesselReportFormik?.values?.position_long_sec}
                            />
                            {CreateVesselReportFormik?.errors.position_long_sec && CreateVesselReportFormik?.touched.position_long_sec &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"position_long_sec"}
                                        message={CreateVesselReportFormik?.errors.position_long_sec}
                                        open={CreateVesselReportFormik?.errors.position_long_sec ? true : false}
                                    />
                                )}
                            <div id='east_west' className='d-flex align-items-center'>
                                <ThreeStateSwitch
                                    formik={CreateVesselReportFormik}
                                    error={CreateVesselReportFormik?.errors.long_direction}
                                    touched={CreateVesselReportFormik?.touched.long_direction}
                                    errorMessage={CreateVesselReportFormik?.errors?.long_direction}
                                    switchLabel={``}
                                    switchLabelId='east_west'
                                    switchFieldName='long_direction'
                                    state1Label='E'
                                    state1Id='east'
                                    state1Value={'east'}
                                    state1DefaultValue={CreateVesselReportFormik?.values?.long_direction === 'east' ? true : false}
                                    state2Label=''
                                    state2Id='long_direction_na'
                                    state2Value={null}
                                    state2DefaultValue={CreateVesselReportFormik?.values?.long_direction === null ? true : false}
                                    state3Label='W'
                                    state3Id='west'
                                    state3Value={'west'}
                                    state3DefaultValue={CreateVesselReportFormik?.values?.long_direction === 'west' ? true : false}
                                    showErrorTooltip={!submitBool}
                                    alertBool={alertBool}
                                />
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row>
                    <Col lg={4}>
                        <div className="form-group mb-2">
                            <Label className="asteric mb-0" for="position_long_deg">
                                Reporting date & time (Local)<i className="bx bx-info-circle ml-2p" id="reporting_time_utc_msg" />
                            </Label>
                            <ToolTip
                                target="reporting_time_utc_msg"
                                message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "reporting_time_utc_msg")
                                    .map((tool: any) => { return tool.message })}`}
                            />
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="datetime-local"
                                id="local_time"
                                name="local_time"
                                className={`datetimepicker text-uppercase ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                min={checkValidObject(previousVesselReport) && previousVesselReport?.local_time?.toString()?.substring(0, 16)}
                                max="2050-12-31T00:00"
                                defaultValue={CreateVesselReportFormik?.values?.local_time?.toString()?.substring(0, 16)}
                                onChange={(e: any) => handleReportingDateTimeChanges(e, false)}
                                onBlur={(e: any) => {
                                    CreateVesselReportFormik?.handleBlur(e);
                                    CreateVesselReportFormik?.handleChange(e);
                                    handleReportingDateTimeChanges(e, true);
                                }}
                                disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                            />
                            {CreateVesselReportFormik?.errors.local_time && CreateVesselReportFormik?.touched.local_time &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"local_time"}
                                        message={CreateVesselReportFormik?.errors.local_time}
                                        open={CreateVesselReportFormik?.errors.local_time ? true : false}
                                    />
                                )}
                        </div>
                    </Col>
                    <Col lg={4}>
                        <Label htmlFor="reporting_time_difference" className="form-label mb-0 asteric">
                            Difference between local time & UTC<i className="bx bx-info-circle ml-2p" id="time_difference_msg" />
                        </Label>
                        <ToolTip
                            target="time_difference_msg"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "time_difference_msg")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <div className="d-flex gap-2">
                            <div id='plus_minus' className='d-flex align-items-center'>
                                <ThreeStateSwitch
                                    formik={CreateVesselReportFormik}
                                    error={CreateVesselReportFormik?.errors.time_difference_prefix}
                                    touched={CreateVesselReportFormik?.touched.time_difference_prefix}
                                    errorMessage={CreateVesselReportFormik?.errors?.time_difference_prefix}
                                    switchLabel={``}
                                    switchLabelId='plus_minus'
                                    switchFieldName='time_difference_prefix'
                                    state1Label='+'
                                    state1Id='plus'
                                    state1Value={'+'}
                                    state1DefaultValue={CreateVesselReportFormik?.values?.time_difference_prefix === '+' ? true : false}
                                    state1onChange={handleTimePrefixSwitchChanges}
                                    state2Label=''
                                    state2Id='time_difference_prefix_na'
                                    state2Value={null}
                                    state2DefaultValue={CreateVesselReportFormik?.values?.time_difference_prefix === null ? true : false}
                                    state3Label='-'
                                    state3Id='minus'
                                    state3Value={'-'}
                                    state3DefaultValue={CreateVesselReportFormik?.values?.time_difference_prefix === '-' ? true : false}
                                    state3onChange={handleTimePrefixSwitchChanges}
                                    showErrorTooltip={!submitBool}
                                    alertBool={alertBool}
                                    isDisabled={editReportBool}
                                />
                            </div>
                            <CleaveInput
                                id="reporting_time_difference"
                                name="reporting_time_difference"
                                placeholder="HH:MM"
                                options={{
                                    time: true,
                                    timePattern: ["h", "m"],
                                }}
                                className={`form-control max-width-5 text-center p-2 max-h-2 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                onChange={(e: any) => {
                                    CreateVesselReportFormik?.handleChange(e);
                                    handleTimeDifferenceTextboxChanges(e, true)
                                }}
                                onBlur={(e: any) => {
                                    CreateVesselReportFormik?.handleBlur(e);
                                    handleTimeDifferenceTextboxChanges(e, true);
                                    handleReportingDateTimeChanges(e, true);
                                }}
                                value={CreateVesselReportFormik?.values?.reporting_time_difference}
                                disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                            />
                            {CreateVesselReportFormik?.errors?.reporting_time_difference && CreateVesselReportFormik?.touched?.reporting_time_difference &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"reporting_time_difference"}
                                        message={CreateVesselReportFormik?.errors.reporting_time_difference}
                                        open={CreateVesselReportFormik?.errors.reporting_time_difference ? true : false}
                                    />
                                )}
                        </div>
                    </Col>
                    <Col lg={4}>
                        <Label className="asteric mb-0" for="no_of_hours_retarded">
                            Hours retarded/advanced since last report?<i className="bx bx-info-circle ml-2p" id="no_of_hours_retarded_msg" />
                        </Label>
                        <ToolTip
                            target="no_of_hours_retarded_msg"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "no_of_hours_retarded_msg")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <div className="input-group">
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control max-width-7 text-right cursor-not-allowed"
                                id="no_of_hours_retarded"
                                name="no_of_hours_retarded"
                                value={CreateVesselReportFormik?.values?.no_of_hours_retarded < 0 ?
                                    CreateVesselReportFormik?.values?.no_of_hours_retarded?.toString()?.substring(1) :
                                    CreateVesselReportFormik?.values?.no_of_hours_retarded
                                }
                                onBlur={CreateVesselReportFormik?.handleBlur}
                                onChange={(e: any) => CreateVesselReportFormik?.handleChange(e)}
                                disabled={true}
                            />
                            <div className="input-group-text round_border">
                                {verifyAdvancedRetarded()}
                            </div>
                        </div>
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col lg={4}>
                        <div className="d-flex flex-wrap mb-2">
                            <Label className="mt-1 min-width-14" for="noon_report">
                                Is this noon report?<i className="bx bx-info-circle ml-2p" id="noon_report_msg" />
                            </Label>
                            <ToolTip
                                target="noon_report_msg"
                                message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "noon_report_msg")
                                    .map((tool: any) => { return tool.message })}`}
                            />
                            <div className="square-switch sqswitch mt-1">
                                <Input
                                    onFocus={(e) => e.target.select()}
                                    type="checkbox"
                                    switch="none"
                                    name="is_noon_report"
                                    id="noon_report"
                                    onChange={(e: any) => handleIsNoonReportSwitchChanges(e)}
                                    defaultChecked={CreateVesselReportFormik?.values?.is_noon_report}
                                    disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                                />
                                <Label
                                    htmlFor="noon_report"
                                    data-on-label="Yes"
                                    data-off-label="No"
                                    className={`${disableEditFields(VesselState)?.permanentDisable ? 'opacity-50 cursor-not-allowed' : ''} mt-1`}
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === " " || e.key === "Enter") {
                                            e.preventDefault();
                                            document.getElementById("noon_report")?.click();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                        <div className="d-flex flex-wrap mb-2">
                            <Label className="mt-1 min-width-14" for="is_cii_adjustment_report">
                                Is this a beginning of CII<br />adjustment FC<sub>voyage</sub> event?
                                <i className="bx bx-info-circle ml-2p" id="cii_adjustment_report_msg" />
                            </Label>
                            <ToolTip
                                target="cii_adjustment_report_msg"
                                message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "cii_adjustment_report_msg")
                                    .map((tool: any) => { return tool.message })}`}
                            />
                            <div className="square-switch sqswitch">
                                <Input
                                    onFocus={(e) => e.target.select()}
                                    type="checkbox"
                                    switch="none"
                                    name="is_cii_adjustment_report"
                                    id="is_cii_adjustment_report"
                                    onChange={(e: any) => handleIsCIIReportSwitchChanges(e)}
                                    defaultChecked={CreateVesselReportFormik?.values?.is_cii_adjustment_report}
                                    disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                                />
                                <Label
                                    htmlFor="is_cii_adjustment_report"
                                    data-on-label="Yes"
                                    data-off-label="No"
                                    className={`${disableEditFields(VesselState)?.permanentDisable ? 'opacity-50 cursor-not-allowed' : ''} mt-1`}
                                    tabIndex={0}
                                    onKeyDown={(e) => {
                                        if (e.key === " " || e.key === "Enter") {
                                            e.preventDefault();
                                            document.getElementById("is_cii_adjustment_report")?.click();
                                        }
                                    }}
                                />
                            </div>
                        </div>
                    </Col>
                    <Col key={refreshCheckboxes}>
                        {CreateVesselReportFormik?.values?.is_noon_report === true &&
                            CreateVesselReportFormik?.values?.is_cii_adjustment_report === true ? (
                            <React.Fragment>
                                <span className={`p-0 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}>
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        className="form-check-input me-1 mt-3"
                                        type="checkbox"
                                        name="cii_noon_combine_with_other_event"
                                        id="cii_combine_with_other_event"
                                        onChange={(e: any) => {
                                            CreateVesselReportFormik?.setFieldValue("cii_noon_combine_with_other_event", e.target.checked);
                                            if (e.target.checked === true) {
                                                CreateVesselReportFormik?.setFieldValue("reporting_event", null);
                                                CreateVesselReportFormik?.setFieldValue("reporting_event_name", null);
                                                setCount(count + 1);
                                            } else {
                                                CreateVesselReportFormik?.setFieldValue(
                                                    "reporting_event",
                                                    reportingEvent[0]?.next_possible_events?.next_possible_events
                                                        .filter((item: any) => item?.event_precedence_id === EventPrecedence.NOON)[0]?.id
                                                );
                                            }
                                        }}
                                        defaultChecked={
                                            CreateVesselReportFormik?.values?.cii_noon_combine_with_other_event
                                        }
                                        disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                                    />
                                </span>
                                <Label for="cii_combine_with_other_event" className='margin-top-0-8 mb-0'>
                                    Is combined with other event?
                                </Label>
                                <br />
                            </React.Fragment>
                        ) : CreateVesselReportFormik?.values?.is_noon_report === true &&
                            CreateVesselReportFormik?.values?.is_cii_adjustment_report === false ? (
                            <div className="ele_row1">
                                <div className={`form-check me-3 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}>
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        className={`form-check-input mt-3 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                        type="radio"
                                        name="only_noon_or_combine_with_other_event"
                                        id="only_noon"
                                        defaultChecked={
                                            CreateVesselReportFormik?.values?.only_noon_or_combine_with_other_event === "combine_with_other_report"
                                                ? false : true
                                        }
                                        onChange={(e: any) => {
                                            CreateVesselReportFormik?.setFieldValue(
                                                "only_noon_or_combine_with_other_event",
                                                e.target.checked === true ? "only_noon_report" : "combine_with_other_report"
                                            );
                                            CreateVesselReportFormik?.setFieldValue(
                                                "reporting_event",
                                                reportingEvent[0]?.next_possible_events?.next_possible_events
                                                    .filter((item: any) => item?.event_precedence_id === EventPrecedence.NOON)[0]?.id
                                            );
                                        }}
                                        disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                                    />
                                    <Label
                                        className={`form-check-label margin-top-0-8 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                        htmlFor="only_noon"
                                    >
                                        Only noon report
                                    </Label>
                                </div>
                                <div className={`form-check ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}>
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        className={`form-check-input mt-3 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                        type="radio"
                                        name="only_noon_or_combine_with_other_event"
                                        id="combined_with_other_event"
                                        onChange={(e: any) => {
                                            CreateVesselReportFormik?.setFieldValue(
                                                "only_noon_or_combine_with_other_event",
                                                e.target.checked === true ? "combine_with_other_report" : "only_noon_report"
                                            );
                                            if (e.target.checked === true) {
                                                CreateVesselReportFormik?.setFieldValue("reporting_event", null);
                                                CreateVesselReportFormik?.setFieldValue("reporting_event_name", null);
                                                setCount(count + 1);
                                            }
                                        }}
                                        defaultChecked={
                                            CreateVesselReportFormik?.values?.only_noon_or_combine_with_other_event === "combine_with_other_report"
                                                ? true : false
                                        }
                                        disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                                    />
                                    <Label
                                        className={`form-check-label margin-top-0-8 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                        htmlFor="combined_with_other_event"
                                    >
                                        Combined with other event
                                    </Label>
                                </div>
                            </div>
                        ) : CreateVesselReportFormik?.values?.is_noon_report === false &&
                            CreateVesselReportFormik?.values?.is_cii_adjustment_report === true ? (
                            <React.Fragment>
                                <Input
                                    onFocus={(e) => e.target.select()}
                                    className={`form-check-input me-1 mt-3 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                    type="checkbox"
                                    id="combined_with_other_event"
                                    name="cii_combine_with_other_event"
                                    onChange={(e: any) => {
                                        CreateVesselReportFormik?.handleChange(e);
                                        if (e.target.checked) {
                                            CreateVesselReportFormik?.setFieldValue("reporting_event", null);
                                            CreateVesselReportFormik?.setFieldValue("reporting_event_name", null);
                                            setCount(count + 1);
                                        } else if (!e.target.checked && !CreateVesselReportFormik?.values?.is_noon_report &&
                                            CreateVesselReportFormik?.values?.is_cii_adjustment_report) {
                                            CreateVesselReportFormik?.setFieldValue("reporting_event",
                                                reportingEvent[0]?.next_possible_events?.next_possible_events
                                                    .filter((item: any) => item?.event_precedence_id === EventPrecedence?.CII_ADJUSTMENT_EVENT)[0]?.id);
                                            CreateVesselReportFormik?.setFieldValue("reporting_event_name",
                                                reportingEvent[0]?.next_possible_events?.next_possible_events
                                                    .filter((item: any) => item?.event_precedence_id === EventPrecedence?.CII_ADJUSTMENT_EVENT)[0]?.name);
                                        }
                                    }}
                                    defaultChecked={CreateVesselReportFormik?.values?.cii_combine_with_other_event}
                                    disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                                />
                                <Label for="combined_with_other_event" className='margin-top-0-8 mb-0'>
                                    Is combined with other event?
                                </Label>
                            </React.Fragment>
                        ) : null}
                    </Col>
                    <Col lg={4}>
                        <Label className="asteric mb-0">
                            Reporting type<i className="bx bx-info-circle ml-2p mb-0" id="reporting_type_msg" />
                        </Label>
                        <br></br>
                        <ToolTip
                            target="reporting_type_msg"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "reporting_type_msg")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <h5 className="mb-0">
                            {checkValidObject(currentVesselReport) &&
                                reportingType === "" ? CreateVesselReportFormik?.values?.reporting_type : reportingType}
                        </h5>
                    </Col>
                </Row>
                <Row className='mb-2'> {/*height-6-25 */}
                    <Col lg={4}>
                        <Label className="asteric mb-0" for="reporting_event">
                            Reporting event<i className="bx bx-info-circle ml-2p" id="reporting_event_msg" />
                        </Label>
                        <ToolTip
                            target="reporting_event_msg"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "reporting_event_msg")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        {((CreateVesselReportFormik?.values?.only_noon_or_combine_with_other_event === "only_noon_report" &&
                            CreateVesselReportFormik?.values?.is_cii_adjustment_report === false &&
                            CreateVesselReportFormik?.values?.cii_noon_combine_with_other_event === false) ||
                            (CreateVesselReportFormik?.values?.is_noon_report === true &&
                                CreateVesselReportFormik?.values?.is_cii_adjustment_report === true &&
                                CreateVesselReportFormik?.values?.cii_noon_combine_with_other_event === false)) ?
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className={`form-control ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                id="reporting_event_disabled"
                                name="reporting_event"
                                value={
                                    reportingEvent &&
                                    reportingEvent[0]?.next_possible_events?.next_possible_events
                                        .filter((item: any) => item?.event_precedence_id === EventPrecedence.NOON)[0]?.event
                                }
                                disabled
                            />
                            : (CreateVesselReportFormik?.values?.is_noon_report === false &&
                                CreateVesselReportFormik?.values?.is_cii_adjustment_report === true &&
                                CreateVesselReportFormik?.values?.cii_noon_combine_with_other_event === false &&
                                CreateVesselReportFormik?.values?.cii_combine_with_other_event === false) ?
                                <Input
                                    onFocus={(e) => e.target.select()}
                                    type="text"
                                    className={`form-control ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                    id="reporting_event_disabled"
                                    name="reporting_event"
                                    value={
                                        reportingEvent?.[0]?.next_possible_events?.next_possible_events
                                            .filter((item: any) => item?.event_precedence_id === EventPrecedence?.CII_ADJUSTMENT_EVENT)[0]?.event
                                    }
                                    disabled
                                />
                                : (CreateVesselReportFormik?.values?.is_noon_report === true &&
                                    CreateVesselReportFormik?.values?.is_cii_adjustment_report === true &&
                                    CreateVesselReportFormik?.values?.cii_noon_combine_with_other_event === true) ||
                                    (CreateVesselReportFormik?.values?.only_noon_or_combine_with_other_event === "combine_with_other_report" &&
                                        CreateVesselReportFormik?.values?.is_cii_adjustment_report === false &&
                                        CreateVesselReportFormik?.values?.cii_noon_combine_with_other_event === false) ||
                                    (CreateVesselReportFormik?.values?.is_noon_report === false &&
                                        CreateVesselReportFormik?.values?.is_cii_adjustment_report === true &&
                                        CreateVesselReportFormik?.values?.cii_combine_with_other_event === true) ||
                                    (CreateVesselReportFormik?.values?.is_noon_report === false &&
                                        CreateVesselReportFormik?.values?.is_cii_adjustment_report === false) ? (
                                    <React.Fragment>
                                        <span
                                            className={`p-0 ${disableEditFields(VesselState)?.permanentDisable ? "cursor-not-allowed" : "pointer"}`}
                                            id='reporting_event'
                                        >
                                            <Select
                                                name="reporting_event"
                                                key={`${count}_${refreshFields}`}
                                                options={eventOptions}
                                                getOptionLabel={e => e.event}
                                                getOptionValue={e => e.id}
                                                value={selectedEvent || null}
                                                onChange={e => {
                                                    setRefreshFieldApplicable(true);
                                                    CreateVesselReportFormik.setFieldTouched("reporting_event", true);
                                                    handleReportingEventDropdownChanges(e);
                                                }}
                                                onMenuOpen={() => setShowTooltipBool(false)}
                                                onMenuClose={() => setShowTooltipBool(true)}
                                                menuPortalTarget={document.body}
                                                styles={customStyle}
                                                className={`mb-0 ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                                onBlur={(e: any) => {
                                                    CreateVesselReportFormik?.handleBlur(e);
                                                }}
                                                isDisabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                                            />
                                        </span>
                                        {CreateVesselReportFormik?.errors?.reporting_event && CreateVesselReportFormik?.touched?.reporting_event &&
                                            env?.form_validation === true && !alertBool && document.getElementById("reporting_event") !== null && !discardwarning &&
                                            showTooltipBool &&
                                            (
                                                <ErrorTooltip
                                                    target={"reporting_event"}
                                                    message={CreateVesselReportFormik?.errors.reporting_event}
                                                    open={!!CreateVesselReportFormik?.errors.reporting_event}
                                                />
                                            )}
                                        {/* <Label className="mt-0 font-smaller mb-0">
                                                                                Select this if you need to choose
                                                                                an event not listed above
                                                                            </Label>
                                                                            <Input
onFocus={(e) => e.target.select()}
                                                                                className="form-check-input mr-1 justify_right"
                                                                                type="checkbox"
                                                                                name="additional_events"
                                                                                id="additional_events"
                                                                                onChange={(e: any) => {
                                                                                    CreateVesselReportFormik?.handleChange(e);
                                                                                }}
                                                                                defaultChecked={CreateVesselReportFormik?.values?.additional_events}
                                                                            />
                                                                            <Label for="additional_events" className='mb-0'>Additional events</Label> */}
                                    </React.Fragment>
                                ) : null
                        }
                    </Col>
                    <Col lg={4}>
                        <Label className="asteric mb-0" for="reporting_operation_mode_name">
                            Reporting operation since last report<i className="bx bx-info-circle ml-2p" id="reporting_operation_mode_msg" />
                        </Label>
                        <ToolTip
                            target="reporting_operation_mode_msg"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "reporting_operation_mode_msg")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <h5 className="mt-2">
                            {previousVesselReport && previousVesselReport?.event_precedence_id === EventPrecedence.NOON &&
                                CreateVesselReportFormik?.values?.only_noon_or_combine_with_other_event === "only_noon_report" ?
                                previousVesselReport?.reporting_operation_mode_name : CreateVesselReportFormik?.values?.reporting_operation_mode_name}
                        </h5>
                    </Col>
                    <Col>
                        {CreateVesselReportFormik?.values &&
                            CreateVesselReportFormik?.values?.reporting_operation_mode === OperationPrecedence.MANEUVERING && (
                                <div className="d-flex flex-wrap gap-2">
                                    <Label for="is_strait_canal_transit">
                                        Is this strait-canal transit? <i className="bx bx-info-circle ml-2p" id="is_strait_canal_transit_lbl" />
                                    </Label>
                                    <ToolTip
                                        target="is_strait_canal_transit_lbl"
                                        message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "is_strait_canal_transit_lbl")
                                            .map((tool: any) => { return tool.message })}`}
                                    />
                                    <div className="square-switch sqswitch">
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            type="checkbox"
                                            switch="none"
                                            name="is_strait_canal_transit"
                                            id="is_strait_canal_transit"
                                            defaultChecked={CreateVesselReportFormik?.values?.is_strait_canal_transit}
                                            onChange={(e: any) => {
                                                CreateVesselReportFormik?.setFieldValue("is_strait_canal_transit", e.target.checked);
                                                if (!e.target.checked) {
                                                    CreateVesselReportFormik?.setFieldValue("strait_canal_transit", null);
                                                    CreateVesselReportFormik?.setFieldValue("strait_canal_transit_name", null);
                                                }
                                            }}
                                        />
                                        <Label
                                            htmlFor="is_strait_canal_transit"
                                            data-on-label="Yes"
                                            data-off-label="No"
                                            tabIndex={0}
                                            onKeyDown={(e) => {
                                                if (e.key === " " || e.key === "Enter") {
                                                    e.preventDefault();
                                                    document.getElementById("is_strait_canal_transit")?.click();
                                                }
                                            }}
                                        />
                                    </div>
                                </div>
                            )}
                    </Col>
                </Row>
                <Row className='mb-2'>
                    <Col lg={4}>
                        <Label className="asteric mb-0" for="load_condition">
                            Vessel load condition<i className="bx bx-info-circle ml-2p" id="load_condition_msg" />
                        </Label>
                        <br></br>
                        <ToolTip
                            target="load_condition_msg"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "load_condition_msg")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <Select
                            name="load_condition"
                            inputId="load_condition"
                            options={LoadConditionOptions}
                            getOptionLabel={(e: any) => e?.load_condition_name}
                            getOptionValue={(e: any) => e?.id}
                            onChange={(selectedOption: any) => {
                                CreateVesselReportFormik?.setFieldValue("load_condition", selectedOption?.id);
                                CreateVesselReportFormik?.setFieldValue('load_condition_name', selectedOption?.load_condition_name);
                            }}
                            onBlur={(selectedOption: any) => {
                                CreateVesselReportFormik?.handleBlur(selectedOption);
                                const currentId = CreateVesselReportFormik?.values?.load_condition;
                                const previousConditionName =
                                    LoadConditionOptions.find(
                                        (item: any) => item.id === previousVesselReport?.load_condition
                                    )?.load_condition_name;

                                const currentConditionName =
                                    LoadConditionOptions.find(
                                        (item: any) => item.id === currentId
                                    )?.load_condition_name;

                                if (
                                    currentId !== previousLoadCondition &&
                                    env?.alerts &&
                                    previousVesselReport?.load_condition &&
                                    previousVesselReport?.load_condition !== currentId &&
                                    (
                                        CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER
                                            ? CreateVesselReportFormik?.values?.change_in_containers_onboard !== "yes"
                                            : CreateVesselReportFormik?.values?.is_this_cargo_loading_discharging !== "yes"
                                    )
                                ) {
                                    setPreviousLoadCondition(currentId);
                                    setAlertColourType(AlertColourTypeConstant.WARNING);
                                    setAlertType(AlertTypeConstant.WITH_REASON);
                                    setAlertMessage(
                                        getAlertMessage(
                                            "VesselReporting",
                                            "load_condition_changed_without_operation",
                                            "Load Condition",
                                            currentConditionName,
                                            previousConditionName
                                        )
                                    );
                                    setFieldId('load_condition');
                                    setAlertBool(true);
                                    setAlertFieldLabel("Load Condition");
                                    setAlertFieldValue(currentId);
                                }
                            }}
                            onMenuOpen={() => setShowTooltipBool(false)}
                            onMenuClose={() => setShowTooltipBool(true)}
                            defaultValue={{
                                id: CreateVesselReportFormik?.values?.load_condition,
                                load_condition_name: CreateVesselReportFormik?.values?.load_condition_name,
                            }}
                            menuPortalTarget={document.body}
                            styles={customStyle}
                        />
                        {CreateVesselReportFormik?.errors?.load_condition && CreateVesselReportFormik?.touched?.load_condition &&
                            env?.form_validation === true && !alertBool && !submitBool && !discardwarning &&
                            showTooltipBool &&
                            (
                                <ErrorTooltip
                                    target={"load_condition"}
                                    message={CreateVesselReportFormik?.errors.load_condition}
                                    open={CreateVesselReportFormik?.errors.load_condition ? true : false}
                                />
                            )}
                    </Col>
                    <Col lg={4}>
                        <Label
                            for="distance_travelled"
                            className="mb-0"
                        >
                            Distance travelled since last report
                            <i
                                className={`bx bx-info-circle ml-2p ${(CreateVesselReportFormik?.values?.reporting_event === ReportingEvents.HEAVE_ANCHOR ||
                                    CreateVesselReportFormik?.values?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH ||
                                    disableEditFields(VesselState)?.permanentDisable) ? "" : "asteric"}`}
                                id="distance_travelled_msg"
                            />
                        </Label>
                        <ToolTip
                            target="distance_travelled_msg"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "distance_travelled_msg")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <div className="input-group">
                            <Input
                                key={refreshDistance}
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className={`form-control max-width-7 text-right ${disableEditFields(VesselState)?.permanentDisable && "cursor-not-allowed"}`}
                                id="distance_travelled"
                                name="distance_travelled"
                                onChange={(e: any) => CreateVesselReportFormik?.handleChange(e)}
                                onBlur={(e: any) => {
                                    CreateVesselReportFormik?.handleChange(e);
                                    CreateVesselReportFormik?.handleBlur(e);
                                    generateDistanceAlert(e.target.value);
                                }}
                                disabled={
                                    (CreateVesselReportFormik?.values?.reporting_event === ReportingEvents.HEAVE_ANCHOR ||
                                        CreateVesselReportFormik?.values?.reporting_event === ReportingEvents.DEPARTURE_FROM_BERTH ||
                                        disableEditFields(VesselState)?.permanentDisable) ?
                                        true : false
                                }
                                value={CreateVesselReportFormik?.values?.distance_travelled}
                            />
                            <div className="input-group-text round_border">
                                nm
                            </div>
                            {CreateVesselReportFormik?.errors.distance_travelled && CreateVesselReportFormik?.touched.distance_travelled &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"distance_travelled"}
                                        message={CreateVesselReportFormik?.errors.distance_travelled}
                                        open={CreateVesselReportFormik?.errors.distance_travelled ? true : false}
                                    />
                                )}
                        </div>
                    </Col>
                    <Col lg={4}>
                        <Label
                            for="remaining_distance_to_the_next_port"
                            className="mb-0"
                        >
                            Remaining distance to the next port
                            <i
                                className="bx bx-info-circle ml-2p"
                                id="remaining_distance_msg"
                            />
                        </Label>
                        <ToolTip
                            target="remaining_distance_msg"
                            message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "remaining_distance_msg")
                                .map((tool: any) => { return tool.message })}`}
                        />
                        <div className="input-group">
                            <Input
                                onFocus={(e) => e.target.select()}
                                type="text"
                                className="form-control max-width-7 text-right"
                                id="remaining_distance_to_the_next_port"
                                name="remaining_distance_to_the_next_port"
                                disabled={reportingType === ReportingTypeConstant.INPORT || CreateVesselReportFormik?.values?.reporting_type === ReportingTypeConstant.INPORT}
                                onChange={CreateVesselReportFormik?.handleChange}
                                onBlur={(e: any) => {
                                    CreateVesselReportFormik?.handleBlur(e);
                                    CreateVesselReportFormik?.handleChange(e);

                                    const lastRemainingDistance = Number(previousVesselReport?.remaining_distance_to_the_next_port);
                                    const distanceTravelled = Number(CreateVesselReportFormik?.values?.distance_travelled);
                                    const currentRemainingDistance = Number(e.target.value);

                                    if (!isNaN(lastRemainingDistance) && !isNaN(distanceTravelled)) {
                                        const expectedRemainingDistance = lastRemainingDistance - distanceTravelled;

                                        if (expectedRemainingDistance > 0) {
                                            const deviation = Math.abs(currentRemainingDistance - expectedRemainingDistance);
                                            const deviationPercentage = (deviation / expectedRemainingDistance) * 100;

                                            if (env?.alerts && deviationPercentage > 10) {
                                                const direction = currentRemainingDistance > expectedRemainingDistance ? "more" : "less";

                                                setAlertBool(true);
                                                setAlertColourType(AlertColourTypeConstant.WARNING);
                                                setAlertType(AlertTypeConstant.WITH_REASON);
                                                setFieldId("remaining_distance_to_the_next_port");
                                                setAlertMessage(
                                                    `The entered remaining distance (${currentRemainingDistance.toFixed(2)} nm) is ${deviationPercentage.toFixed(
                                                        1
                                                    )}% ${direction} than the expected value (${expectedRemainingDistance.toFixed(
                                                        2
                                                    )} nm) based on the last report.`
                                                );
                                            }
                                        }
                                    }
                                }}
                                value={CreateVesselReportFormik?.values?.remaining_distance_to_the_next_port}
                            />
                            <div className="input-group-text round_border">
                                nm
                            </div>
                            {CreateVesselReportFormik?.errors.remaining_distance_to_the_next_port &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"remaining_distance_to_the_next_port"}
                                        message={CreateVesselReportFormik?.errors.remaining_distance_to_the_next_port}
                                        open={CreateVesselReportFormik?.errors.remaining_distance_to_the_next_port ? true : false}
                                    />
                                )}
                        </div>
                    </Col>
                </Row>
                <Row className={`${(CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.TANKER ||
                    CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER ||
                    CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP
                ) ? 'mb-5' : 'mb-2'} height-5`}>
                    {CreateVesselReportFormik?.values &&
                        CreateVesselReportFormik?.values?.reporting_event !== ReportingEvents.NOON_FWE_IP &&
                        CreateVesselReportFormik?.values?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
                        CurrentVessel?.vessel_type_precedence_id !== VesselTypeConstant.CONTAINER &&
                        <Col lg={4}>
                            <div id='is_this_cargo_loading_discharging'>
                                <ThreeStateSwitch
                                    formik={CreateVesselReportFormik}
                                    error={CreateVesselReportFormik?.errors.is_this_cargo_loading_discharging}
                                    touched={CreateVesselReportFormik?.touched.is_this_cargo_loading_discharging}
                                    errorMessage={CreateVesselReportFormik?.errors?.is_this_cargo_loading_discharging}
                                    switchLabel={`Is there any change in cargo onboard?`}
                                    switchLabelId='is_this_cargo_loading_discharging'
                                    switchFieldName='is_this_cargo_loading_discharging'
                                    state1Label='Yes'
                                    state1Id='yes'
                                    state1Value={'yes'}
                                    state1DefaultValue={CreateVesselReportFormik?.values?.is_this_cargo_loading_discharging === 'yes' ? true : false}
                                    state2Label=''
                                    state2Id='na'
                                    state2Value={null}
                                    state2DefaultValue={CreateVesselReportFormik?.values?.is_this_cargo_loading_discharging === null ? true : false}
                                    state3Label='No'
                                    state3Id='no'
                                    state3Value={'no'}
                                    state3DefaultValue={CreateVesselReportFormik?.values?.is_this_cargo_loading_discharging === 'no' ? true : false}
                                    showErrorTooltip={!submitBool}
                                    alertBool={alertBool}
                                />
                            </div>
                        </Col>
                    }
                    {CreateVesselReportFormik?.values &&
                        CreateVesselReportFormik?.values?.reporting_event !== ReportingEvents.NOON_FWE_IP &&
                        CreateVesselReportFormik?.values?.reporting_event !== ReportingEvents.DEPARTURE_FROM_BERTH &&
                        (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.CONTAINER ||
                            CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.GENERAL_CARGO_SHIP) &&
                        OtherSettings && OtherSettings[0]?.is_container_available === true &&
                        <React.Fragment>
                            <Col lg={4}>
                                <div id="change_in_containers_onboard">
                                    <ThreeStateSwitch
                                        formik={CreateVesselReportFormik}
                                        error={CreateVesselReportFormik?.errors.change_in_containers_onboard}
                                        touched={CreateVesselReportFormik?.touched.change_in_containers_onboard}
                                        errorMessage={CreateVesselReportFormik?.errors?.change_in_containers_onboard}
                                        switchLabel={`Is there any change in no. of containers onboard?`}
                                        switchLabelId='change_in_containers_onboard'
                                        switchFieldName='change_in_containers_onboard'
                                        state1Label='Yes'
                                        state1Id='yes'
                                        state1Value={'yes'}
                                        state1DefaultValue={CreateVesselReportFormik?.values?.change_in_containers_onboard === 'yes' ? true : false}
                                        state2Label=''
                                        state2Id='na'
                                        state2Value={null}
                                        state2DefaultValue={CreateVesselReportFormik?.values?.change_in_containers_onboard === null ? true : false}
                                        state3Label='No'
                                        state3Id='no'
                                        state3Value={'no'}
                                        state3DefaultValue={CreateVesselReportFormik?.values?.change_in_containers_onboard === 'no' ? true : false}
                                        alertBool={alertBool}
                                    />
                                </div>
                            </Col>

                            {CreateVesselReportFormik?.errors?.change_in_containers_onboard &&
                                CreateVesselReportFormik?.touched?.change_in_containers_onboard &&
                                env?.form_validation === true && !alertBool && !discardwarning && (
                                    <ErrorTooltip
                                        target={"change_in_containers_onboard"}
                                        message={CreateVesselReportFormik?.errors.change_in_containers_onboard}
                                        open={CreateVesselReportFormik?.errors.change_in_containers_onboard ? true : false}
                                    />
                                )}
                        </React.Fragment>
                    }
                    {CreateVesselReportFormik?.values?.reporting_operation_mode === OperationPrecedence.MANEUVERING &&
                        calculateTimeDurationBetwnReports
                            (previousVesselReport?.reporting_time_utc, CreateVesselReportFormik?.values?.reporting_time_utc) >= ManeouveringTimeLimit &&
                        <Col lg={4}>
                            <div className="d-flex flex-wrap gap-2">
                                <Label className="mt-2 max-width-13" for="is_drifting_involved">
                                    Is drifting involved since last report?<i className="bx bx-info-circle ml-2p" id="is_drifting_involved_msg" />
                                </Label>
                                <ToolTip
                                    target="is_drifting_involved_msg"
                                    message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "is_drifting_involved_msg")
                                        .map((tool: any) => { return tool.message })}`}
                                />
                                <div className="square-switch sqswitch mt-1">
                                    <Input
                                        onFocus={(e) => e.target.select()}
                                        type="checkbox"
                                        switch="none"
                                        name="is_drifting_involved"
                                        id="is_drifting_involved"
                                        onChange={(e: any) => CreateVesselReportFormik?.setFieldValue("is_drifting_involved", e.target.checked)}
                                        defaultChecked={CreateVesselReportFormik?.values?.is_drifting_involved}
                                    />
                                    <Label
                                        htmlFor="is_drifting_involved"
                                        data-on-label="Yes"
                                        data-off-label="No"
                                        className="mt-1"
                                    />
                                </div>
                            </div>
                        </Col>
                    }
                    {CreateVesselReportFormik?.values &&
                        CreateVesselReportFormik?.values?.is_strait_canal_transit === true &&
                        CreateVesselReportFormik?.values?.reporting_operation_mode === OperationPrecedence.MANEUVERING &&
                        (
                            <Col lg={4}>
                                <React.Fragment>
                                    <Label className="mb-0 asteric" for="strait_canal_transit">
                                        Strait-Canal transit<i className="bx bx-info-circle ml-2p" id="strait_canal" />
                                    </Label>
                                    <br></br>
                                    <ToolTip
                                        target="strait_canal"
                                        message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "strait_canal")
                                            .map((tool: any) => { return tool.message })}`}
                                    />
                                    <Select
                                        name="strait_canal_transit"
                                        inputId="strait_canal_transit"
                                        options={StraitCanals?.sort((a: any, b: any) => a.strait_canal_transit.localeCompare(b.strait_canal_transit))}
                                        getOptionLabel={(e) => e.strait_canal_transit}
                                        getOptionValue={(e) => e.id}
                                        onChange={(selectedOption: any) => {
                                            CreateVesselReportFormik?.setFieldValue("strait_canal_transit", selectedOption?.id ?? null);
                                            CreateVesselReportFormik?.setFieldValue('strait_canal_transit_name', selectedOption?.strait_canal_transit);
                                        }}
                                        defaultValue={{
                                            id: CreateVesselReportFormik?.values?.strait_canal_transit,
                                            strait_canal_transit: CreateVesselReportFormik?.values?.strait_canal_transit_name,
                                        }}
                                        menuPortalTarget={document.body}
                                        styles={customStyle}
                                        isClearable={true}
                                        onBlur={(e: any) => {
                                            CreateVesselReportFormik?.handleBlur(e);
                                        }}
                                    />
                                    {CreateVesselReportFormik?.errors?.strait_canal_transit &&
                                        CreateVesselReportFormik?.touched?.strait_canal_transit &&
                                        env?.form_validation === true && !alertBool && !discardwarning && (
                                            <ErrorTooltip
                                                target={"strait_canal_transit"}
                                                message={CreateVesselReportFormik?.errors.strait_canal_transit}
                                                open={CreateVesselReportFormik?.errors.strait_canal_transit ? true : false}
                                            />
                                        )}
                                </React.Fragment>
                            </Col>

                        )}
                    {checkValidObject(currentVesselReport) &&
                        (CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.TANKER ||
                            CurrentVessel?.vessel_type_precedence_id === VesselTypeConstant.LNG_CARRIER) &&
                        (reportingType === "" ? CreateVesselReportFormik?.values?.reporting_type : reportingType) === ReportingTypeConstant.INPORT && (
                            <Col lg={4}>
                                <div className="d-flex flex-wrap">
                                    <Label className="min-width-14" for="is_sts_considered">
                                        Is this the beginning of an<br />
                                        STS operation? <i className="bx bx-info-circle ml-2p" id="is_sts_considered_msg" />
                                    </Label>
                                    <ToolTip
                                        target="is_sts_considered_msg"
                                        message={`${TooltipMsg.CreateReport.filter((item: any) => item.target === "is_sts_considered_msg")
                                            .map((tool: any) => { return tool.message })}`}
                                    />
                                    <div className="square-switch sqswitch mt-1">
                                        <Input
                                            onFocus={(e) => e.target.select()}
                                            type="checkbox"
                                            switch="none"
                                            name="is_sts_considered"
                                            id="is_sts_considered"
                                            onChange={(e: any) => CreateVesselReportFormik?.setFieldValue("is_sts_considered", e.target.checked)}
                                            defaultChecked={CreateVesselReportFormik?.values?.is_sts_considered}
                                            disabled={disableEditFields(VesselState)?.permanentDisable ?? false}
                                        />
                                        <Label
                                            htmlFor="is_sts_considered"
                                            data-on-label="Yes"
                                            data-off-label="No"
                                            className="mt-1"
                                        />
                                    </div>
                                </div>
                            </Col>
                        )}
                </Row>
                <Row className='mb-0'>
                    {editReportBool ?
                        <CardFooter className="p-2 py-3">
                            <div className="d-flex flex-wrap gap-3 grp_justify_right">
                                <Button
                                    type="button"
                                    color="primary"
                                    className="btn_size_cstm"
                                    onClick={async () => {
                                        // Validate the entire form
                                        await CreateVesselReportFormik.validateForm();
                                        // Mark all fields as touched
                                        Object.keys(CreateVesselReportFormik.values).forEach((key) => {
                                            CreateVesselReportFormik.setFieldTouched(key, true);
                                        });
                                        // If no validation errors and editReportBool is true
                                        if (editReportBool && Object.keys(CreateVesselReportFormik.errors).length === 0) {
                                            await saveEditForm(editSubmit, toggle, activeEditTab);
                                            setRefreshKey(refreshKey + 1);
                                        }
                                    }}
                                    disabled={editIsSubmitting}
                                >
                                    {editIsSubmitting && <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />}
                                    Next <i className="bx bx-chevron-right ms-1" />
                                </Button>
                                {/* <Button
                                    type="reset"
                                    color="danger"
                                    className="btn_size_cstm"
                                    onClick={() => {
                                        setEditValues({
                                            ...editValues,
                                            vessel_reporting_information: editInitalValues?.vessel_reporting_information,
                                        })
                                        CreateVesselReportFormik?.resetForm();
                                        setCount(count + 1);
                                        setRefreshKey(refreshKey + 1);
                                    }}
                                >
                                    Reset
                                </Button> */}
                            </div>
                        </CardFooter> :
                        <div className="d-flex flex-wrap gap-3 grp_justify_right btn_Margin">
                            <Button
                                type="button"
                                color="primary"
                                key={refreshKey}
                                onClick={async () => {
                                    // Validate the form before submission
                                    const errors = await CreateVesselReportFormik.validateForm();
                                    if (Object?.keys(errors)?.length === 0) {
                                        // No validation errors — show popup
                                        setSubmitBool(true);
                                    } else {
                                        CreateVesselReportFormik?.setTouched(
                                            Object?.keys(errors)?.reduce((acc, key) => {
                                                acc[key] = true;
                                                return acc;
                                            }, {} as any)
                                        );
                                    }
                                }}
                                disabled={CreateVesselReportFormik?.isSubmitting}
                            >
                                Save and Submit
                            </Button>
                            <Button
                                type="submit"
                                color="primary"
                                className="btn_size4_5_cstm"
                                disabled={CreateVesselReportFormik?.isSubmitting}
                            >
                                {CreateVesselReportFormik.isSubmitting ? <i className="ms-2 spinner-border spinner-border-sm text-light me-2" /> : "Save"}
                            </Button>
                            <Button
                                type="reset"
                                color="danger"
                                className="btn_size4_5_cstm"
                                onClick={() => {
                                    CreateVesselReportFormik?.resetForm();
                                    setCount(count + 1);
                                    setRefreshKey(refreshKey + 1);
                                }}
                            >
                                Reset
                            </Button>
                        </div>
                    }
                </Row>
                {
                    submitBool &&
                    <PopUp
                        state={submitBool}
                        setState={setSubmitBool}
                        title="Submit Confirmation"
                        size="md"
                        body={
                            <React.Fragment>
                                Are you sure you want to create the report?<br />
                                Once submitted, the report cannot be edited.
                                <p>Click <strong>Yes</strong> to proceed or <strong>No</strong> to cancel.</p>
                                <div className='d-flex justify-content-end gap-3 m-2'>
                                    <button
                                        onClick={() => {
                                            CreateVesselReportFormik?.handleSubmit();
                                        }}
                                        disabled={CreateVesselReportFormik?.isSubmitting}
                                        className="btn btn-primary">
                                        {CreateVesselReportFormik.isSubmitting && <i className="ms-2 spinner-border spinner-border-sm text-light me-2" />}
                                        Yes
                                    </button>
                                    <button onClick={() => setSubmitBool(false)} className="btn btn-danger">No</button>
                                </div>
                            </React.Fragment>
                        }
                    />
                }
                <FormValuesDebug values={[CreateVesselReportFormik?.values, CreateVesselReportFormik?.errors, CreateVesselReportFormik?.initialValues]} />
            </form>
        </CardBody >
    )
}

export default CreateVesselReportStructure